import LazyLoadedImage from 'Components/shared/LazyLoadedImage';
import { useContext, useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
	getAlbums,
	photoSrc,
	sortedPhotoKeys,
	themeVariant,
} from 'modules/gallery';
import Theme from 'contexts/Theme';

export default () => {
	const [metadata, setMetadata] = useState({});
	const [loaded, setLoaded] = useState(false);
	const theme = useContext(Theme);
	const { collectionId } = useParams();

	const fetchMetadata = async () => {
		const metadata = await getAlbums();

		setMetadata(metadata);
		setLoaded(true);
	};

	useEffect(() => {
		fetchMetadata();
	}, []);

	if (!loaded) {
		return;
	}

	const collectionMetadata = metadata[collectionId];

	if (!collectionMetadata) {
		return (
			<div className='h-full w-full flex flex-col place-items-center p-5'>
				<span className='text-xl'>Collection not found</span>
			</div>
		);
	}

	const imagesMap = sortedPhotoKeys(collectionMetadata).map(
		(fileName, index) => {
			const imageMetadata = collectionMetadata.photos[fileName];
			const path = `${collectionId}/${fileName}`;

			return (
				<Link
					key={path}
					to={`/photo-view/${collectionId}/${fileName}`}
					className={
						imageMetadata?.orientation === 'landscape'
							? 'col-[span_3_/_auto]'
							: ''
					}>
					<LazyLoadedImage
						notLazy={index === 0}
						src={photoSrc(
							collectionId,
							themeVariant(theme),
							fileName,
							imageMetadata
						)}
						width={imageMetadata?.width}
						height={imageMetadata?.height}
						className={`w-full h-full ${
							imageMetadata?.fit === false ? '' : 'object-cover'
						}`}
						alt={path}
						placeholderSrc={photoSrc(
							collectionId,
							'lowres',
							fileName,
							imageMetadata
						)}
					/>
				</Link>
			);
		}
	);

	return (
		<div className='h-full w-full flex flex-col gap-5 place-items-center p-5'>
			<div className='flex flex-col gap-2 place-items-center'>
				<span className='text-xl'>{collectionMetadata.date}</span>
				<span className='text-xl'>
					{collectionMetadata.description}
				</span>
			</div>
			<div className='grid grid-cols-3 gap-2 sm:gap-[25px] auto-rows-auto grid-flow-dense pb-5'>
				{imagesMap}
			</div>
		</div>
	);
};
